module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.currentPasswordError()
    }
  }, [_c('label', [_vm._v("Current Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.currentPassword),
      callback: function($$v) {
        _vm.currentPassword = $$v
      },
      expression: "currentPassword"
    }
  }), _vm._v(" "), (_vm.currentPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.newPasswordError()
    }
  }, [_c('label', [_vm._v("New Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), (_vm.newPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.confirmPasswordError()
    }
  }, [_c('label', [_vm._v("Re-Type Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  }), _vm._v(" "), (_vm.confirmPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Passwords do not match")]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0280e7b6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/account/change-password.vue
// module id = 633
// module chunks = 2